module.exports = "<script type=\"text/html\" id=\"survey-question-expression\">\n  <div data-bind=\"text:question.displayValue, css: question.koCss().root\"></div>\n</script>\n";


//////////////////
// WEBPACK FOOTER
// ./src/knockout/templates/question-expression.html
// module id = 87
// module chunks = 0